import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order_statistics",
  "use": "icon-order_statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-order_statistics\"><defs><style type=\"text/css\"></style></defs><path d=\"M495.3 300.5c-100.3 10.5-187 101.1-187 208.6 0 115.2 93.4 208.6 208.6 208.6 84.8 0 157.7-50.7 190.3-123.4l-211.9-63.5V300.5z m28.7-43.2v248.8L753.4 575c10.1-25.2 15.2-52.1 15.2-79.3 0-131.7-123-238.4-244.6-238.4z m-11.2 703.3C265.7 960.6 65.3 760.2 65.3 513S265.7 65.5 512.8 65.5 960.4 265.9 960.4 513 760 960.6 512.8 960.6z\" fill=\"\" p-id=\"1963\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order_statistics.svg
// module id = jVsL
// module chunks = 30